/* */
export const sortMembers = (a, b) => (a.lastname && a.lastname.length) - (b.lastname && b.lastname.length);

export const sortMembersByLastnameLength = (a, b) => sortMembers(a, b);

export const sortMembersAlphabetically = (a, b) => {
  let res = a.lastname.localeCompare(b.lastname);
  if (res === 0) res = a.firstname.localeCompare(b.firstname);
  return res;
};

/* */
export const noop = () => {};
